import { BehaviorSubject, Observable } from 'rxjs';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {FormBuilder, FormGroup} from '@angular/forms';
import {EventEmitter, Injectable} from '@angular/core';
import {FiltroEventConfig} from './filtro-event.config';
import {FiltroSelectedConfig} from './filtro-selected.config';
import {IndexedDbModel} from '../../../../../models/indexed-db.model';

@Injectable({ providedIn: 'root' })
export class FiltroRoteirizacaoService {

  private filtroAtual: FiltroSelectedConfig;
  // tslint:disable-next-line:variable-name
  private _formGroupFiltro: FormGroup;
  idUsuario: string = null;
  filtrouEvent: BehaviorSubject<FiltroEventConfig> = new BehaviorSubject<FiltroEventConfig>({entregas: []});

  constructor(public formBuilder: FormBuilder, private dbService: NgxIndexedDBService) {
    this.getFiltrosStorage().subscribe((filtros) => {
      if (filtros.length) {
        const filtro = filtros[0];
        filtro.idUsuarioFilial = this.idUsuario;
        this.filtro = filtro;
      }
    });
  }

  set filtro(value) {
    this.filtroAtual = value;
  }

  get filtro(): FiltroSelectedConfig {
    return this.filtroAtual;
  }

  get formGroupFiltro() {
    return this._formGroupFiltro;
  }

  set formGroupFiltro(value) {
    this._formGroupFiltro = value;
  }

  criarFormulario() {
    this.formGroupFiltro = this.formBuilder.group({
      filiais: [],
      rotas: [],
      pracas: [],
      ufs: [],
      cidades: [],
      dataPedidoInicio: [],
      dataPedidoFim: [],
      rcas: [],
      regioes: [],
      supervisores: [],
      distribuicoes: [],
      restricoesTransporte: [],
      ramoAtividades: [],
      idCliente: [],
      planosPagamento: [],
      cobrancas: [],
      prioridadeSeparacao: [],
      dataAgendamentoInicial: [],
      dataAgendamentoFinal: [],
      dataPrevisaoFaturamentoInicial: [],
      dataPrevisaoFaturamentoFinal: [],
      tipoVendas: [],
      diasMontagemRota: [],
      posicaoPedidos: [],
      tipoBloqueioCliente: [],
      mapaSeparacaoEmitido: [],
      pedidosConferidos: [],
      pedidosProcessadosWms: [],
      volumeMinimo: [],
      volumeMaximo: [],
      valorMinimo: [],
      valorMaximo: [],
      pesoMinimo: [],
      pesoMaximo: [],
      transportadoras: [],
      departamentos: [],
      tipoFreteDespacho: [],
      validarZonaRestricao: [],
      pedidosImportacaoXML: [],
      mapaSemaparacaoEmitidoWMS: [],
      restricaoTranspProduto: [],
      restricaoTranspProdutoTodos: [],
      tiposPessoa: [],
      numerosPedidos: [],
      fornecedores: [],
      produtos: [],
      origemVenda: [],
      categorias: [],
      diaVisita: [],
      exibirPedidosReentrega: [],
      turnoEntrega: [],
      tipoTurnoEntrega: 'PED',
      centroDeDistribuicao: [],
      entregasCrossDocking: [],
      regioesAtendimento: [],
      dataLiberacaoInicio: [],
      dataLiberacaoFim: [],
      valorEntregaMinimo: [],
      valorEntregaMaximo: [],
      filialOrdenacao: [],
      diasAtendimento: [],
      filiaisRetira: [],
      tipoAvulso: [],
      palavrasChaves: [],
      preAgendamento: [],
      palavraChaveCampo: [],
      carregametosTransbordo: []
    });

    return this.formGroupFiltro;
  }

  obterFiltros(): FiltroSelectedConfig {
    if (this.formGroupFiltro) {
      const filtro = this.formGroupFiltro.getRawValue();
      filtro.idCliente = this.pegarIdClienteSeForObjeto(filtro);


      filtro.idUsuarioFilial = this.idUsuario;
      this.filtro = filtro;
      this.salvarFiltroStorage(filtro);
    }
    return this.filtro;
  }

  private pegarIdClienteSeForObjeto(filtro: any) {
    const idCliente = filtro.idCliente;

    if (Array.isArray(idCliente) && idCliente.length > 0 && typeof idCliente[0] === 'object') {
      return idCliente.map(cliente => cliente.id) || null;
    }

    return idCliente || null;
  }

  removerFiltrosStorage() {
    try {
      this.dbService.clear(IndexedDbModel.DB_ROTEIRIZAZAO_FILTROS).subscribe(() => {});
    } catch (error) {
      console.log(error.message);
    }
  }

  getFiltrosStorage(): Observable<Array<FiltroSelectedConfig>> {
    try {
      return this.dbService.getAll(IndexedDbModel.DB_ROTEIRIZAZAO_FILTROS);
    } catch (error) {
      console.log(error.message);
    }
  }

  salvarFiltroStorage(filtros: FiltroSelectedConfig) {
    try {
      this.dbService.clear(IndexedDbModel.DB_ROTEIRIZAZAO_FILTROS).subscribe(() => {
        this.dbService.add(IndexedDbModel.DB_ROTEIRIZAZAO_FILTROS, filtros).subscribe(() => {});
      });
    } catch (error) {
      console.log(error.message);
    }
  }
}


